<aumico-users-quick-sign-up-page
    [supportedLocales]="supportedLocales"
    [countries]="countries"
    [defaultLanguage]="defaultLanguage"
    (isPersonalInformationStep)="onStepsChange($event)"
    (signUpSuccess)="onSignUpSuccess($event)"
></aumico-users-quick-sign-up-page>

<app-component-random-questions-with-action-button
    *ngIf="!isPersonalInformationCurrentStep"
    [question]="loginQuestionTextKey"
    [actionButton]="{title: loginQuestionButtonTextKey, action: questionButtonClickedAction}"
>
</app-component-random-questions-with-action-button>
